module.exports = __webpack_public_path__ + "media/images/x-square-0e2f5c2f.svg";